export default __webpack_public_path__ + "static/media/genas.77d5d9fa.png";